export interface IdType {
    idType: string;
    type: string;
}

export function idTypeActions() {
    function idType(
        idType: string,
        type: string
    ): IdType {
        return {
            idType: idType,
            type: type
        };
    }

    return {
        idType,
    };
}


